/**
 * Created by piotr.pozniak@thebeaverhead.com on 05/04/2022.
 */
import {
  overwriteWidgetFilters,
  overwriteWidgetSettings,
  updateWidgetSettings,
} from "./widgetReducerTools";

const initialState = {
  model: null,

  fetch: false,
  fetchError: null,
  fetchSuccess: null,

  update: false,
  updateSuccess: false,
  updateError: null,

  delete: false,
  deleteSuccess: false,
  deleteError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "GROUP_SET":
      if (!action.payload) {
        return { ...initialState };
      }

      return {
        ...initialState,
        model: action.payload,
      };

    case "GROUP_FETCH_FULFILLED":
      try {
        return {
          ...state,
          fetch: false,
          fetchSuccess: true,
          model: {
            ...state.model,
            ...action.payload,
          },
        };
      } catch (e) {
        console.log("Group Fetch Fulfilled, an exception occurred: ", e);
      }

    case "GROUP_UPDATE":
      return {
        ...state,
        update: true,
        updateSuccess: false,
        updateError: null,
      };

    case "GROUP_UPDATE_FULFILLED":
      return {
        ...state,
        model: {
          ...action.payload,
        },
        update: false,
        updateSuccess: true,
      };

    case "GROUP_UPDATE_REJECTED":
      return {
        ...state,
        update: false,
        updateError: action.payload,
      };

    case "GROUP_DELETE":
      return {
        ...state,
        delete: true,
        deleteSuccess: false,
        deleteError: null,
      };

    case "GROUP_DELETE_FULFILLED":
      return {
        ...state,
        model: null,
        delete: false,
        deleteSuccess: true,
      };

    case "GROUP_DELETE_REJECTED":
      return {
        ...state,
        delete: false,
        deleteError: action.payload,
      };

    case "WIDGET_DESIGN_PROP_UPDATE":
      if (!state.model) {
        break;
      }

      return updateWidgetSettings(state, action);

    case "WIDGET_DESIGN_PROP_OVERWRITE":
      if (!state.model) {
        break;
      }
      return overwriteWidgetSettings(state, action);

      case "WIDGET_FILTER_PROP_OVERWRITE":
      if (!state.model) {
        break;
      }
      return overwriteWidgetFilters(state, action);

    /*
    case "GROUP_FILTERS_FETCH_FULFILLED":
      return {
        ...state,
        model: {
          ...state.model,
          group_filters:
            action.payload && action.payload.length
              ? action.payload.map((i) => i.id)
              : [],
        },
      };*/

    case "CLEAR_ERRORS":
      return {
        ...initialState,
        model: state.model ? { ...state.model } : null,
      };

    default:
      return state;
  }

  return state;
}
